import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { UtmifyScript } from './components/UtmifyScript';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-stone-50 text-stone-900 antialiased" data-id="element-0" data-mp="28sl4n0mhvsgk">
      <MetaPixel data-id="element-1" data-mp="23u9uspw79hyc" />
      <UtmifyScript data-id="element-2" data-mp="23utas12ahw9q" />
      <CountdownBar data-id="element-3" data-mp="23t8h0dnsuhcx" />
      <main data-id="element-4" data-mp="3ik7gwiph6frp">
        <Hero data-id="element-5" data-mp="3ikhaeg9qb525" />
        <StatsBar data-id="element-6" data-mp="3iiweam7rne26" />
        <Difference data-id="element-7" data-mp="3ijfw82xf22g7" />
        <Recognize data-id="element-8" data-mp="3ihv0wb3a2fha" />
        <WhatsInside data-id="element-9" data-mp="3mlj6wpc9h30f" />
        <LookInside data-id="element-10" data-mp="3mkre1ma1tjdu" />
        <InstantAccess data-id="element-11" data-mp="3mk85gw6ag7ch" />
        <Bonuses data-id="element-12" data-mp="3mjg9hk8s47lo" />
        <Offer data-id="element-13" data-mp="3rc9f0ac2njyt" />
        <Guarantee data-id="element-14" data-mp="3rcj2nr9n9f1c" />
        <Testimonials data-id="element-15" data-mp="3rdaquh0wwahl" />
        <Faq data-id="element-16" data-mp="3rcswxr1q28cu" />
      </main>
      <Footer data-id="element-17" data-mp="3relvej26lm9r" />
    </div>;
}